import { put } from 'redux-saga/effects';
import { getMessagingAccessTokenDocument } from '../../gql/getMessagingAccessTokenDocument';
import { firebaseActions } from '../../redux/firebaseActions';

export function* getNewToken(): Generator {
    yield put(firebaseActions.requestNewTokenGQL(getMessagingAccessTokenDocument));
}
